var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.768433 4.56015C0.768433 2.56319 2.38729 0.944336 4.38425 0.944336H11.6159C13.6129 0.944336 15.2317 2.56319 15.2317 4.56015V11.7918C15.2317 13.7888 13.6129 15.4076 11.6159 15.4076H4.38425C2.38729 15.4076 0.768433 13.7888 0.768433 11.7918V4.56015Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.55996C0 2.13865 1.96286 0.175781 4.38418 0.175781H11.6158C14.0371 0.175781 16 2.13865 16 4.55996V11.7916C16 14.2129 14.0371 16.1758 11.6158 16.1758H4.38418C1.96286 16.1758 0 14.2129 0 11.7916V4.55996ZM4.38418 1.7125C2.81157 1.7125 1.53672 2.98735 1.53672 4.55996V11.7916C1.53672 13.3642 2.81157 14.6391 4.38418 14.6391H11.6158C13.1884 14.6391 14.4633 13.3642 14.4633 11.7916V4.55996C14.4633 2.98735 13.1884 1.7125 11.6158 1.7125H4.38418Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.076 5.86655C12.3745 6.16812 12.3745 6.65707 12.076 6.95865L8.6676 10.4016C8.01982 11.056 6.97028 11.0583 6.31969 10.4068L4.58693 8.67159C4.28709 8.37133 4.28498 7.88238 4.58223 7.5795C4.87947 7.27661 5.3635 7.27449 5.66334 7.57475L7.3961 9.30994C7.44885 9.36276 7.53395 9.36258 7.58647 9.30952L10.9948 5.86655C11.2934 5.56497 11.7774 5.56497 12.076 5.86655Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOk);
export default __webpack_public_path__ + "static/media/icon_check_ok.ca9881e46bc969a27f833d101621a07d.svg";
export { ForwardRef as ReactComponent };